export enum VenueRateView {
  ChartView = 'Chart',
  TableView = 'Table'
}

export const MODAL_MAX_MONTHS = 12;
export const MODAL_MIN_MONTHS = 6;
export const TABLE_VIEW = 0;
export const CHART_VIEW = 1;
export const NUMBER_OF_MONTHS = 6;
export const NUM_Y_AXIS_TICKS = 4;

export const LOCATION = 'Location';
